export const scienceFacts = [
    "Light travels at 299,792 kilometers per second in a vacuum.",
    "DNA contains approximately 3 billion base pairs in humans.",
    "The human heart creates enough pressure to squirt blood 30 feet.",
    "The average person breathes about 23,000 times a day.",
    "The universe is expanding faster than the speed of light.",
    "The Earth’s core is as hot as the surface of the Sun, at about 5,500°C (9,932°F).",
    "Octopuses have three hearts and blue blood.",
    "There are more molecules in a cup of water than there are stars in the observable universe.",
    "Bananas are naturally radioactive due to their potassium-40 content.",
    "Your bones are about five times stronger than steel of the same density.",
    "The Great Wall of China is not visible from space with the naked eye.",
    "Sharks existed before trees; they have been around for over 400 million years.",
    "The smell of rain comes from bacteria in the soil, known as geosmin.",
    "A day on Venus is longer than a year on Venus due to its slow rotation.",
    "One drop of liquid water contains more molecules than all the grains of sand on Earth.",
    "Honey never spoils; archaeologists have found edible honey in ancient Egyptian tombs.",
    "There are more bacterial cells in your body than human cells.",
    "Black holes can slow down time due to extreme gravitational effects.",
    "Saturn’s moon Titan has lakes of liquid methane and ethane.",
    "Your stomach gets a new lining every few days to prevent it from digesting itself.",
    "Fire can burn in zero gravity, but it forms a sphere instead of a flame.",
    "The Eiffel Tower grows taller in summer due to heat expansion.",
    "A year on Mercury lasts just 88 Earth days.",
    "Hot water freezes faster than cold water in some conditions, known as the Mpemba effect.",
    "The largest living organism is a fungus in Oregon covering over 3.8 square miles.",
    "The human eye can distinguish about 10 million different colors.",
    "The Sun makes up more than 99% of the mass of our solar system.",
    "The deepest part of the ocean, the Mariana Trench, is deeper than Mount Everest is tall.",
    "Sound travels about 4 times faster in water than in air.",
    "If you could fold a piece of paper 42 times, it would reach the Moon.",
    "There is a giant cloud of alcohol in space, Sagittarius B2, containing enough alcohol for trillions of drinks.",
    "Plants can recognize their siblings and will grow cooperatively next to them.",
    "A single lightning bolt is five times hotter than the surface of the Sun.",
    "A day on Earth is gradually getting longer due to the Moon’s gravitational pull.",
    "There is enough DNA in the human body to stretch from the Earth to the Sun and back over 600 times.",
    "Your brain generates enough electricity to power a small lightbulb.",
    "Whales can hold their breath for over an hour.",
    "A cockroach can live for a week without its head.",
    "Glass is actually a slow-moving liquid, not a solid.",
    "Earth is the only known planet where fire can burn, as it requires oxygen.",
    "Neptune was mathematically predicted before it was directly observed.",
    "Jellyfish are biologically immortal; they do not die of old age.",
    "The entire Internet weighs about the same as a strawberry in terms of energy stored in electrons.",
    "Humans share about 60% of their DNA with bananas."
];